var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,23h-6v-2h5V3H5V21h5v2H4l-1-1V2l1-1H20l1,1V22l-1,1Zm-3-18h-2v3h2v-3Zm-4,0h-2v3h2v-3Zm-4,0h-2v3h2v-3Zm8,5h-2v3h2v-3Zm-4,0h-2v3h2v-3Zm-4,0h-2v3h2v-3Zm8,5h-2v3h2v-3Zm-4,0h-2v3h2v-3Zm-4,0h-2v3h2v-3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompany);
export default __webpack_public_path__ + "static/1765206080/media/icon-company.6bebf33d3487f67f249fb696e96ce044.svg";
export { ForwardRef as ReactComponent };